// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderManagement_container__1fy5A","content":"OrderManagement_content__2n0-X","contentInner":"OrderManagement_contentInner__d8O4X"};